import React from "react";
import DateRangePicker from "./library/DateRangePicker";
import { DateModes, PageState } from "../utils/types";
import StateHelper from "../utils/StateHelper";
import { Popover, OverlayTrigger } from "react-bootstrap";
import dayjs from "../utils/dayjs";

interface DateRangeSelectorProps {
  startDate:dayjs.Dayjs;
  endDate:dayjs.Dayjs;
  onChange: (start : dayjs.Dayjs,end: dayjs.Dayjs, dateMode: DateModes) => void;
}

function DateRangeSelector(props: DateRangeSelectorProps) {
  const [show, setShow] = React.useState(false);
  const pageState : PageState = StateHelper.getPageState();
  
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(!show);

  let dateModeFormat:string;
  switch ( pageState.dateMode ) {
    case "days":
      dateModeFormat = "YYYY-MM-DD";
      break;
    case "months":
      dateModeFormat = "YYYY-MM (MMM)";
      break;
    case "weeks":
      dateModeFormat="YYYY-MM-DD ([W]W)";
      break;
  }
  

  return (
    <>
      <OverlayTrigger
        trigger="click"
        key={"overlayTrigger"}
        placement={"bottom-start"}
        rootClose={true}
        delay={0}
        show={show}
        overlay={
          <Popover id="dateRangeSelector" style={{ maxWidth: "650px" }}>
            <Popover.Content style={{ padding: "5px" }}>
              <DateRangePicker
                onClickOutside={() => {handleShow()}} 
                startDate={props.startDate}
                endDate={props.endDate}
                minDate="2021-01-01"
                onRangeSelect={props.onChange}
                onClose={handleClose}
                dateMode={pageState.dateMode}
              />
            </Popover.Content>
          </Popover>
        }
      >
        <input
          type="text"
          placeholder={(dayjs.utc(props.startDate).format(dateModeFormat) + " - " + dayjs.utc(props.endDate).format(dateModeFormat))}
          className="form-control form-control-sm w-100 "
          onClick={() => handleShow()}
          style={{ height: "auto", fontSize: "12px" }}
        />
      </OverlayTrigger>
    </>
  );
}

export default DateRangeSelector;
